import { render, staticRenderFns } from "./ShowPlayerModal.vue?vue&type=template&id=c65d0e16&"
import script from "./ShowPlayerModal.vue?vue&type=script&lang=js&"
export * from "./ShowPlayerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports